import { Crisp } from 'crisp-sdk-web';

(() => {
  Crisp.configure('94725ce6-189a-43d0-85aa-fedee0c2ca3a');
})();
